// `/sign-in/error` (spec/07 §3.1; infra/runbooks/social-sign-in.md): where the api sends a refused Google, Discord or
// Steam sign-in when it cannot tell which screen started it (a state nobody issued, or one already used), with
// `?error=<code>`. Never better-auth's own error page, which is switched off. The page says what happened in plain
// words, never the code itself, and offers the way back: sign in again, or the home page. A code it does not know
// reads as "something went wrong".

import { useTranslation } from '@clavian/i18n/react';
import { Button } from '@clavian/ui-web';
import { Link, useSearch } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { AuthLayout } from './AuthLayout';
import { socialRefusal } from './social';

export function SignInErrorPage(): ReactNode {
  const { t } = useTranslation('player');
  const { error } = useSearch({ from: '/sign-in/error' });
  const refusal = socialRefusal(error) ?? 'generic';

  return (
    <AuthLayout title={t('signInError.title')}>
      <p className="pw-alert" role="alert">
        {t(`signInError.error.${refusal}`)}
      </p>
      <div className="pw-form">
        {refusal === 'noAccount' ? (
          <Button asChild variant="primary" block>
            <Link to="/sign-up">{t('social.signUpInstead')}</Link>
          </Button>
        ) : (
          <Button asChild variant="primary" block>
            <Link to="/sign-in">{t('signInError.back')}</Link>
          </Button>
        )}
        <Button asChild variant="ghost" block>
          <Link to="/">{t('signInError.home')}</Link>
        </Button>
      </div>
    </AuthLayout>
  );
}
